/**
 * 작성자 : 박승호
 * 날짜 : 2024.09.04
 * 기능 : 파일 업로드 버튼 컴포넌트
 */

import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { handleFlutterFilePicker } from '../../hooks/crossPlatformHook/useFlutterFilePicker';

const Root = styled.div`
  width: auto;
  height: 2.5rem;
  border-radius: 5px;
  overflow: hidden;
  color: #eaeaea;
  background-color: #626777;
  flex-grow: unset !important;
  cursor: pointer;

  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }

  &:hover {
    color: #eaeaea;
    background-color: #3f4254;
  }

  &.red {
    color: var(--btn-text);
    background-color: var(--filled-red);
    &:hover {
      background-color: rgba(246, 78, 96, 0.6);
    }
    &:disabled {
      background-color: rgba(246, 78, 96, 0.6);
      cursor: default;
    }
  }

  &.green {
    background-color: #0f766e;
    &:hover {
      color: #fff;
      background-color: #115e59;
    }
  }

  &.blue {
    background-color: var(--selected-primary);
    &:hover {
      background-color: var(--blue-60);
    }
    &:disabled {
      background-color: var(--filled-blue-light);
      cursor: default;
    }
  }

  & > label {
    display: flex;
    justify-content: center;
    align-items: center;
    width: auto !important;
    height: 100%;
    font-size: 0.875rem;
    color: #eaeaea;
    padding: 0 0.6rem;
    cursor: pointer;

    .flex-box {
      display: flex;
      align-items: center;
    }
  }

  input {
    display: none;
  }

  .material-symbols-rounded {
    margin-right: 0.2rem;
    color: #eaeaea;
    font-size: 1rem;
    font-variation-settings: 'FILL' 1, 'wght' 500, 'GRAD' 0, 'opsz' 20;
  }
`;

type Props = {
  id: string;
  name: string;
  ico?: 'music_note' | 'description' | 'video_cam' | 'upload';
  color?: 'red' | 'green' | 'blue';
  label: string;
  className?: string;
  accept: string;
  multiple?: 'Y' | 'N';
  handleChange: (e: any) => any;
  disabled?: boolean;
  allowAllFileTypes?: 'all' | 'image';
  uploadByFlutter?: boolean;
};

const FileUploadButton = ({ id, name, ico, color, label, className, accept, multiple, handleChange, disabled = false, allowAllFileTypes = 'image', uploadByFlutter = false }: Props) => {
  const { t } = useTranslation();

  return (
    <Root role='button' className={`${disabled ? 'disabled' : ''} ${color}`}>
      <label htmlFor={id} className={className}>
        <div className='flex-box' onClick={() => handleFlutterFilePicker(undefined, allowAllFileTypes, uploadByFlutter)} role='button' tabIndex={0}>
          {ico && <span className='material-symbols-rounded'>{ico}</span>}
          <span>{t(label)}</span>
        </div>
      </label>
      <input type='file' id={id} name={name} accept={accept} disabled={disabled} onChange={handleChange} multiple={multiple === 'Y' ? !false : false} />
    </Root>
  );
};

export default FileUploadButton;
